import { render, staticRenderFns } from "./LogoFaviconSettings.vue?vue&type=template&id=c62b3b60&scoped=true"
import script from "./LogoFaviconSettings.vue?vue&type=script&lang=js"
export * from "./LogoFaviconSettings.vue?vue&type=script&lang=js"
import style0 from "./LogoFaviconSettings.vue?vue&type=style&index=0&id=c62b3b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62b3b60",
  null
  
)

export default component.exports